import { DateTime } from "luxon";
import type { FieldValues } from "react-hook-form";
import { FormLineItem } from "../FormLineItem";
import { FormDatePicker } from "../fields/FormDatePicker";
import type { FormLineItemProps } from "../types";

export type FormDateLineItemProps<TFieldValues extends FieldValues> =
	FormLineItemProps<TFieldValues> & {
		defaultMonth?: DateTime;
		fromDate?: DateTime;
		toDate?: DateTime;
		disableBefore?: string | null;
		disableAfter?: string | null;
		disableDays?: string[];
		errorMessage?: string;
		readonly?: boolean;
		compact?: boolean;
	};

export const FormDateLineItem = <TFieldValues extends FieldValues>({
	formMethods,
	name,
	label,
	id,
	tooltip,
	className,
	labelClassName,
	partialRequiresSubmit,
	defaultMonth,
	fromDate,
	toDate,
	disableBefore,
	disableAfter,
	disableDays,
	errorMessage,
	readonly,
	compact,
}: FormDateLineItemProps<TFieldValues>) => {
	const { control } = formMethods;
	return (
		<FormLineItem
			formMethods={formMethods}
			id={id}
			name={name}
			label={label}
			tooltip={tooltip}
			className={className}
			labelClassName={labelClassName}
			partialRequiresSubmit={partialRequiresSubmit}
		>
			<FormDatePicker
				name={name}
				control={control}
				defaultMonth={defaultMonth}
				fromDate={fromDate}
				toDate={toDate}
				disableBefore={disableBefore}
				disableAfter={disableAfter}
				disableDays={disableDays}
				errorMessage={errorMessage}
				readonly={readonly}
				compact={compact}
			/>
		</FormLineItem>
	);
};
